import { render, staticRenderFns } from "./BrandComponentSearch.vue?vue&type=template&id=77e6572f&scoped=true"
import script from "./BrandComponentSearch.vue?vue&type=script&lang=js"
export * from "./BrandComponentSearch.vue?vue&type=script&lang=js"
import style0 from "./BrandComponentSearch.vue?vue&type=style&index=0&id=77e6572f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e6572f",
  null
  
)

export default component.exports